import axios from 'axios';

// JWT lives in localStorage under this key. Kept here (not imported from
// services/auth.js) so the request interceptor has no dependency cycle:
// auth.js imports `api` from this module, so importing back would create a
// circular import that the production build can leave undefined at runtime.
const TOKEN_KEY = 'drill.jwt';
const getToken = () => {
  try {
    return localStorage.getItem(TOKEN_KEY) || null;
  } catch {
    return null;
  }
};

// Base URL for the API. In dev, Vite proxies /api -> :5000; the browser
// only ever talks to the same origin, so no CORS or absolute URL needed.
// The production Caddy edge serves /api too, so this stays correct there.
//
// IMPORTANT: use `import.meta.env` here, not `process.env`. Vite only
// replaces `import.meta.env.*` at build time; `process.env.*` survives into
// the bundle and evaluates to `undefined` in the browser, which would leave
// baseURL empty and send every API request to the SPA origin (where a POST
// like /auth/register returns 405 instead of hitting the proxy).
const API_BASE = import.meta.env.VITE_API_BASE || '';

export const api = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' },
});

// Attach the JWT to every request as soon as we have one.
api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Normalize responses and reject non-2xx with a readable error.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const message =
      error?.response?.data?.error ||
      error.message ||
      'Ne známá chyba';
    const normalized = new Error(message);
    normalized.response = error.response;
    normalized.status = error.response?.status ?? error.status;
    return Promise.reject(normalized);
  }
);

export default api;
